import React from 'react';
import config from '../../config';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Row, Col, Table, Modal} from 'react-bootstrap';
import * as commonActions from '../../actions/commonActions';
import * as studentActions from '../../actions/studentsActionCreators';
import label from '../../utils/lngEn';
import Spinner from 'react-spinkit';
import CustomPagination from '../common/CustomPagination';


class AddReleaseModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      name: {
        value: '', style: null, message: ''
      },
      restrictionModal: {
        title: '',
        gsId: '',
        initialValues: {
          is_time_conflict: false
        }
      },
      restrictionsList: [],
      restrictionsTable: [],
      activeRestrictionsPage: 1,
      startRest: 0,
      endRest: 10
    }


    this.setRestrictionsToState = this.setRestrictionsToState.bind(this);
    this.pageBack = this.pageBack.bind(this);
    this.pageForward = this.pageForward.bind(this);
    this.checkKey = this.checkKey.bind(this);
    this.handleRestrictionSearch = this.handleRestrictionSearch.bind(this);

  }
  componentWillMount() {
    this.props.studentActions.getAllStudentRestrictions(this.props.student.id);
    document.onkeydown = this.checkKey;
  }

  componentWillReceiveProps(nextProps) {
    this.setState({restrictionModal: nextProps.initial});
    if(nextProps.student.restrictions != this.props.student.restrictions) {
      this.setRestrictionsToState(nextProps.student.restrictions);
    }
  }
  handleAddRelease(id, studentId, type) {
    this.props.studentActions.addStudentRelease(id, studentId, type);
  }

  setRestrictionsToState(restrictions) {
    let restrictionsList = [];
    if(restrictions.run_locks.length > 0) {
      restrictions.run_locks.map(restriction => {
        let obj = {};
        obj.typeTitle = label.run_lock;
        obj.type = config.run_locks;
        obj.id = restriction.id;
        obj.name = restriction.course;
        restrictionsList.push(obj);
      });
    }
    if(restrictions.run_conflicts.length > 0) {
      restrictions.run_conflicts.map(restriction => {
        let obj = {};
        obj.typeTitle = label.run_conflict;
        obj.type = config.run_conflicts;
        obj.id = restriction.id;
        obj.name = restriction.name;
        obj.courses = restriction.courses;
        restrictionsList.push(obj);
      });
    }
    if(restrictions.run_requirements.length > 0) {
      restrictions.run_requirements.map(restriction => {
        let obj = {};
        obj.id = restriction.id;
        obj.typeTitle = label.run_requirement;
        obj.type = config.run_requirements;
        obj.name = restriction.name;
        obj.courses = restriction.courses;
        restrictionsList.push(obj);
      });
    }
    if(restrictions.group_locks.length > 0) {
      restrictions.group_locks.map(restriction => {
        let obj = {};
        obj.id = restriction.id;
        obj.typeTitle = label.group_lock;
        obj.type = config.group_locks;
        obj.name = restriction.course;
        restrictionsList.push(obj);
      });
    }
    if(restrictions.group_conflicts.length > 0) {
      restrictions.group_conflicts.map(restriction => {
        let obj = {};
        obj.id = restriction.id;
        obj.typeTitle = label.group_conflict;
        obj.type = config.group_conflicts;
        obj.name = restriction.name;
        obj.courses = restriction.courses;
        restrictionsList.push(obj);
      });
    }
    if(restrictions.group_requirements.length > 0) {
      restrictions.group_requirements.map(restriction => {
        let obj = {};
        obj.id = restriction.id;
        obj.typeTitle = label.group_requirement;
        obj.type = config.group_requirements;
        obj.name = restriction.name;
        obj.courses = restriction.courses;
        restrictionsList.push(obj);
      });
    }


    restrictionsList.map((r, index) => {
      let filterArray = this.props.overridesList.filter(o => {
        return o.id == r.id && o.type == r.type;
      });
      if(filterArray.length > 0) {
        delete restrictionsList[index];
      }
    });

    this.setState({restrictionsList: restrictionsList, restrictionsTable: restrictionsList});
  }



  pageBack() {
    let newActivePage = this.state.activeRestrictionsPage -1;
    this.setState({activeRestrictionsPage: newActivePage});
    if(newActivePage == 1) {
      this.setState({startRest: 0, endRest: 10});
    } else {
      let start = newActivePage*10 - 10 ;
      let end = newActivePage*10;
      this.setState({startRest: start, endRest:end});
    }
  }
  pageForward() {
    let newActivePage = this.state.activeRestrictionsPage +1;
    this.setState({activeRestrictionsPage: newActivePage});
    let start = newActivePage*10 - 10 ;
    let end = newActivePage*10;
    this.setState({startRest: start, endRest:end});
  }

  checkKey(e) {
    if(this.refs.rest){
      e = e || window.event;
      if (e.keyCode == '37') {
        // left arrow
        if(this.state.activeRestrictionsPage > 1) {
          this.pageBack();
        }
      }
      else if (e.keyCode == '39') {
        // right arrow
        if(this.state.activeRestrictionsPage < Math.ceil(this.state.restrictionsList.length/10)) {
          this.pageForward();
        }
      }
    }
  }

  // Handle Restriction item Search
  handleRestrictionSearch(e) {
    e.preventDefault();
    let term = e.target.value;
    if(term != '') {
      let arrUnique = this.searchRestrictions(term, this.state.restrictionsList, this.props.courses);
      this.setState({restrictionsTable: arrUnique, startRest: 0, endRest: 10, activeRestrictionsPage: 1});
    } else {
      this.setState({restrictionsTable:this.state.restrictionsList});
    }
  }

  searchRestrictions(term,restrictions,courses) {
    let b = restrictions.filter(restriction => {
      if(restriction.type == config.run_locks || restriction.type ==  config.group_locks) {
        return restriction.name.toString().toLowerCase().indexOf(term.toLowerCase()) != -1;
      } else {
        let cArray = [];
        restriction.courses.forEach(id => {
          let e = courses.filter(c => {
            return c.id == id;
          });
          e.map(f => {
            if(f.slug.toLowerCase().indexOf(term.toLowerCase()) != -1 || f.longname.toLowerCase().indexOf(term.toLowerCase()) != -1) {
              cArray.push(f);
            }
          });
        });
        let bool = () => {if(cArray.length > 0) {return true;} else {return false;}};
        return bool() || restriction.name.toLowerCase().indexOf(term.toLowerCase()) != -1;
      }
    });

    return b;
}




  render(){
    return (
      <Modal show={this.props.showModal} onHide={this.props.closeModal} bsSize="large" className="addConflictModal">
        <Modal.Header closeButton>
          <Modal.Title>
            <Row>
              <Col md={12} className="modal-title">
                {this.state.restrictionModal.title || label.createReleaseModalTitle}
              </Col>
            </Row>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>{this.state.restrictionModal.initialValues.id ? '' : label.createReleaseModalBody}</p>
          <input
            name="restrictionsSearchInput"
            onChange={(e)=>{this.handleRestrictionSearch(e)}}
            type="text"
            className="form-control"
            placeholder="Type Restriction name or Course name/slug..."/>
          <span className="input-description">Type restriction name, course slug or name to filter restrictions</span>
          <div className="c-table classes-table mt-2 mb-2 height480">
            {this.state.restrictionsList.length > 0 ?
              <div>
                <Table condensed hover ref="rest">
                  <thead>
                  <tr>
                    <th>Restriction Type</th>
                    <th>Restriction Name</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  {this.state.restrictionsTable.slice(this.state.startRest, this.state.endRest).map((restriction,index) => {
                    return <tr key={index}>
                      <td className="class-desc">{restriction.typeTitle}</td>
                      <td className="class-desc">{restriction.name}</td>
                      <td className="class-edit"><span onClick={()=>{this.handleAddRelease(restriction.id, this.props.student.id, restriction.type)}}>Add</span></td>
                    </tr>
                  })}
                  </tbody>

                </Table>
                <CustomPagination
                  activePage={this.state.activeRestrictionsPage}
                  onBack={this.pageBack}
                  onForward={this.pageForward}
                  listLength={Math.ceil(this.state.restrictionsTable.length/10)}/>
              </div>
              : <Spinner spinnerName="three-bounce" className="mt-4"/>}
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    student: state.student,
    courses: state.courses // delete
  };
}

function mapDispatchToProps(dispatch) {
  return {
    commonActions: bindActionCreators(commonActions, dispatch),
    studentActions: bindActionCreators(studentActions, dispatch)
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(AddReleaseModal);



// WEBPACK FOOTER //
// ./src/components/students/AddReleaseModal.js